import React from 'react';

import { Row, Col } from 'antd';

import clsx from 'clsx';
import PermissionHide from 'v2/components/Shared/PermissionHide';

import { Link } from './Link';

interface CardProps {
  title: string;
  subtitle: string;
  link: string;
  disabled?: boolean;
  permission?: string;
  userTypes?: string[];
  allowWithoutPermission?: boolean;
  target?: string;
}

const cards: CardProps[] = [
  {
    title: 'Comissões pagas a afiliados',
    subtitle: 'Verifique quanto você já pagou de comissão a seus afiliados.',
    link: '/producer/reports/sales/commissions/affiliates',
    permission: 'myeduzz:reports:visualizar'
  },
  {
    title: 'Comissões pagas a parceiros',
    subtitle: 'Verifique quanto você já pagou de comissão a seus parceiros (coprodutores).',
    link: '/producer/reports/sales/commissions/partners',
    permission: 'myeduzz:reports:visualizar'
  },
  {
    title: 'Reembolsos',
    subtitle: 'Confira os reembolsos realizados em suas vendas. ',
    link: '/producer/reports/sales/refunds',
    permission: 'myeduzz:reports:visualizar'
  },
  {
    title: 'Motivos de Cancelamento e Suspensão',
    subtitle: 'Saiba porque seus contratos têm sido cancelados ou suspensos.',
    link: '/producer/reports/sales/cancel',
    permission: 'myeduzz:reports:visualizar'
  },
  {
    title: 'Chargebacks',
    subtitle: 'Gerencie os chargebacks solicitados pelos clientes.',
    link: '/producer/chargebacks',
    permission: 'myeduzz:chargeback:visualizar',
    userTypes: ['producer']
  },
  {
    title: 'Sugerir novo relatório',
    subtitle: 'Vote em qual será o próximo relatório a ser disponibilizado ou sugira um novo relatório',
    link: 'https://surveys.hotjar.com/f9ad4cec-c6be-458b-921a-b85083ee27cb',
    allowWithoutPermission: true
  }
];

export const Cards = () => {
  return (
    <Row gutter={[16, 16]}>
      {cards.map(card => (
        <PermissionHide
          allowWithoutPermission={card.allowWithoutPermission}
          userTypes={card.userTypes}
          action={card.permission}
          key={card.title}
        >
          <Col className='relative' xs={24} sm={12} md={6}>
            <Link
              className={clsx(
                'flex h-full flex-col bg-white p-3 shadow-[0_4px_10px_0_rgb(0_0_0/7%)] max-md:min-h-[100px]',
                card.disabled ? 'pointer-events-none opacity-50' : 'transition-transform duration-200 hover:scale-105'
              )}
              {...card}
            >
              <h3 className='text-text-heading mb-2 text-base uppercase'>{card.title}</h3>
              <p className='text-sm text-[#7c7c7c]'>{card.subtitle}</p>
            </Link>
          </Col>
        </PermissionHide>
      ))}
    </Row>
  );
};
